import React from 'react';
import '@ingka/svg-icon/dist/style.css';
import SkapaSelect from '@ingka/select';
import Option from '@ingka/select/Option';

interface SkapaSelectProps {
  id: string;
  items: Array<{ key: string; value: any; disabled?: boolean }>;
  onChange: (value: any) => void;
  value?: any;
  label?: string;
  testDataPrefix?: string;
  hintText?: string;
  disabled?: boolean;
}

const Select = ({ id, items, onChange, testDataPrefix, ...props }: SkapaSelectProps) => {
  return (
    <SkapaSelect {...props} id={id} onChange={event => onChange(event.target.value)}>
      {items.map(item => (
        <Option
          data-testid={`${testDataPrefix}-option-${item.value}-${item.disabled && 'disabled'}`}
          key={item.key}
          name={item.key}
          value={item.value}
          disabled={item.disabled}
        />
      ))}
    </SkapaSelect>
  );
};

export default Select;
